exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add-btn-container[data-v-bb4d2d38]{display:flex;align-items:center;justify-content:center;padding-top:12px\n}\n.space-x>*[data-v-bb4d2d38]:not(:first-child):not(:last-child){margin-right:.5rem;margin-left:.5rem\n}\n.credits-list[data-v-bb4d2d38]{margin-top:16px;max-height:200px;overflow-y:auto\n}\n.credits-list .md-list-item[data-v-bb4d2d38]{display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid rgba(0,0,0,.12)\n}\n.credits-list .credit-info[data-v-bb4d2d38]{display:flex;flex-direction:column;flex:1\n}\n.credits-list .credit-name[data-v-bb4d2d38]{font-weight:500;font-size:14px\n}\n.credits-list .credit-role[data-v-bb4d2d38]{font-size:12px;color:#757575;text-transform:capitalize\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-bb4d2d38","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/forms/CreditsForm.vue
// module id = 197
// module chunks = 0